import DefaultListItem from "@tiptap/extension-list-item";
import cn from "classnames";

import "./style.scss";

import { checkIfAfterTable, checkIfFirstListItem } from "./util";

const ListItem = DefaultListItem.extend({
    addAttributes() {
        return {
            ...this.parent?.(),
            helpText: {
                default: false,
                parseHTML: (element) => element.classList.contains("help-text"),
            },
            hasComment: {
                default: false,
            },
            class: {
                default: undefined,
                renderHTML: (attributes) => {
                    return {
                        class: cn({
                            "help-text": attributes.helpText,
                            "has-comment": attributes.hasComment,
                        }),
                    };
                },
            },
            "data-diff-node": {
                default: undefined,
                renderHTML: (attributes) => {
                    return {
                        class: cn({
                            inserted: attributes["data-diff-node"] === "inserted",
                            deleted: attributes["data-diff-node"] === "deleted",
                            changed: attributes["data-diff-node"] === "changed",
                        }),
                    };
                },
            },
        };
    },

    addKeyboardShortcuts() {
        return {
            ...this.parent?.(),
            // Needed to allow for a bullet list item that is right after a table to be deleted (formatting removed)
            Backspace: ({ editor }) => {
                const { state } = editor;
                const { selection, doc } = state;
                const { from, to, $anchor } = selection;

                let listItem;

                doc.nodesBetween(from, to, (node, _pos, parent) => {
                    if (node.type.name === "paragraph" && parent.type.name === "listItem") {
                        listItem = parent;
                    }
                });

                if (!listItem) {
                    return false;
                }

                if (!$anchor.parentOffset === 0) {
                    return false;
                }

                const list = $anchor.node(-2);

                if (!checkIfAfterTable(doc, list, selection)) {
                    return false;
                }

                if (!checkIfFirstListItem(doc, listItem, selection)) {
                    return false;
                }

                return editor.chain().focus().toggleList(list.type.name, "listItem").run();
            },
        };
    },
});

export default ListItem;
